import BlSpinnerAv from './BlSpinnerAv.vue'

BlSpinnerAv.install = function(Vue) {
  Vue.component(BlSpinnerAv.name, BlSpinnerAv)
}

export default BlSpinnerAv
